// import RulePack from './RulePack';

export default {
  priority: 30,
  path: "packet",
  permissions: ["Salary/SalaryWritMenu"], // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./RulePack")
  ),
  name: app.translate(" احکام حقوق و دستمزد"),
  icon: "content-paste",
  drawer: true,
};
